import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, StakeInput } from "../baseItems";
import Base from "./base";

const BANKS = [
	{ "value": "BANXICO", "label": "BANXICO" },
	{ "value": "BANCOMEXT", "label": "BANCOMEXT" },
	{ "value": "BANOBRAS", "label": "BANOBRAS" },
	{ "value": "BANJERCITO", "label": "BANJERCITO" },
	{ "value": "NAFIN", "label": "NAFIN" },
	{ "value": "BaBien", "label": "BaBien" },
	{ "value": "HIPOTECARIA FED", "label": "HIPOTECARIA FED" },
	{ "value": "BANAMEX", "label": "BANAMEX" },
	{ "value": "BBVA MEXICO", "label": "BBVA MEXICO" },
	{ "value": "SANTANDER", "label": "SANTANDER" },
	{ "value": "HSBC", "label": "HSBC" },
	{ "value": "BAJIO", "label": "BAJIO" },
	{ "value": "INBURSA", "label": "INBURSA" },
	{ "value": "MIFEL", "label": "MIFEL" },
	{ "value": "SCOTIABANK", "label": "SCOTIABANK" },
	{ "value": "BANREGIO", "label": "BANREGIO" },
	{ "value": "INVEX", "label": "INVEX" },
	{ "value": "BANSI", "label": "BANSI" },
	{ "value": "AFIRME", "label": "AFIRME" },
	{ "value": "BANORTE", "label": "BANORTE" },
	{ "value": "BANK OF AMERICA", "label": "BANK OF AMERICA" },
	{ "value": "MUFG", "label": "MUFG" },
	{ "value": "JP MORGAN", "label": "JP MORGAN" },
	{ "value": "BMONEX", "label": "BMONEX" },
	{ "value": "VE POR MAS", "label": "VE POR MAS" },
	{ "value": "AZTECA", "label": "AZTECA" },
	{ "value": "AUTOFIN", "label": "AUTOFIN" },
	{ "value": "BARCLAYS", "label": "BARCLAYS" },
	{ "value": "COMPARTAMOS", "label": "COMPARTAMOS" },
	{ "value": "MULTIVA BANCO", "label": "MULTIVA BANCO" },
	{ "value": "ACTINVER", "label": "ACTINVER" },
	{ "value": "INTERCAM BANCO", "label": "INTERCAM BANCO" },
	{ "value": "BANCOPPEL", "label": "BANCOPPEL" },
	{ "value": "ABC CAPITAL", "label": "ABC CAPITAL" },
	{ "value": "CONSUBANCO", "label": "CONSUBANCO" },
	{ "value": "VOLKSWAGEN", "label": "VOLKSWAGEN" },
	{ "value": "CIBANCO", "label": "CIBANCO" },
	{ "value": "BBASE", "label": "BBASE" },
	{ "value": "BANKAOOL", "label": "BANKAOOL" },
	{ "value": "PAGATODO", "label": "PAGATODO" },
	{ "value": "INMOBILIARIO", "label": "INMOBILIARIO" },
	{ "value": "DONDE", "label": "DONDE" },
	{ "value": "BANCREA", "label": "BANCREA" },
	{ "value": "BANCO COVALTO", "label": "BANCO COVALTO" },
	{ "value": "ICBC", "label": "ICBC" },
	{ "value": "SABADELL", "label": "SABADELL" },
	{ "value": "SHINHAN", "label": "SHINHAN" },
	{ "value": "MIZUHO BANK", "label": "MIZUHO BANK" },
	{ "value": "BANK OF CHINA", "label": "BANK OF CHINA" },
	{ "value": "BANCO S3", "label": "BANCO S3" },
	{ "value": "MONEXCB", "label": "MONEXCB" },
	{ "value": "GBM", "label": "GBM" },
	{ "value": "MASARI", "label": "MASARI" },
	{ "value": "VALUE", "label": "VALUE" },
	{ "value": "VECTOR", "label": "VECTOR" },
	{ "value": "FINAMEX", "label": "FINAMEX" },
	{ "value": "VALMEX", "label": "VALMEX" },
	{ "value": "PROFUTURO", "label": "PROFUTURO" },
	{ "value": "CB INTERCAM", "label": "CB INTERCAM" },
	{ "value": "CI BOLSA", "label": "CI BOLSA" },
	{ "value": "FINCOMUN", "label": "FINCOMUN" },
	{ "value": "NU MEXICO", "label": "NU MEXICO" },
	{ "value": "STP", "label": "STP" },
	{ "value": "CREDICAPITAL", "label": "CREDICAPITAL" },
	{ "value": "KUSPIT", "label": "KUSPIT" },
	{ "value": "UNAGRA", "label": "UNAGRA" },
	{ "value": "ASP INTEGRA OPC", "label": "ASP INTEGRA OPC" },
	{ "value": "LIBERTAD", "label": "LIBERTAD" },
	{ "value": "CAJA POP MEXICA", "label": "CAJA POP MEXICA" },
	{ "value": "CRISTOBAL COLON", "label": "CRISTOBAL COLON" },
	{ "value": "CAJA TELEFONIST", "label": "CAJA TELEFONIST" },
	{ "value": "TRANSFER", "label": "TRANSFER" },
	{ "value": "FONDO (FIRA)", "label": "FONDO (FIRA)" },
	{ "value": "CREDICLUB", "label": "CREDICLUB" },
	{ "value": "FOMPED", "label": "FOMPED" },
	{ "value": "INDEVAL", "label": "INDEVAL" },
	{ "value": "CoDi Valida", "label": "CoDi Valida" },
	{ "value": "ARCUS", "label": "ARCUS" },
	{ "value": "ALTERNATIVOS", "label": "ALTERNATIVOS" },
	{ "value": "NVIO", "label": "NVIO" },
	{ "value": "Cuenca", "label": "Cuenca" },
	{ "value": "TESORED", "label": "TESORED" },
	{ "value": "Mercado Pago W", "label": "Mercado Pago W" },
	{ "value": "CLS", "label": "CLS" },
];

export default class APay extends Base {
	onSelectBankCode(e) {
		this.setState(
			{
				bank_code: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { method } = this.props;
		const { bank_code } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					{method === "APayMpesa" && (
						<FormItem onRegister={() => this.registerField({ name: "phone_number" })}>
							<Box>
								<BoxTitle>{translate("PHONE_NUMBER")}</BoxTitle>
								<MaskedInput>
									<MaskInput
										alwaysShowMask={window.IS_MARS ? true : false}
										maskChar="_"
										mask="\2\5\4000000000"
										size={12}
										onChange={this.onEnterValue.bind(this, "phone_number")}
									/>
								</MaskedInput>
							</Box>
						</FormItem>
					)}
					{method === "APayBankAlFalah" && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="_________________"
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>
							<FormItem
								onRegister={() => this.registerField({ name: "iban_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<MaskedInput>
										<MaskInput
											alwaysShowMask={window.IS_MARS ? true : false}
											maskChar="_"
											mask="\T\R00 0000 0000 0000 0000 0000 00"
											size={24}
											onChange={this.onEnterValue.bind(this, "iban_number")}
										/>
									</MaskedInput>
								</Box>
							</FormItem>
							<FormItem
								onRegister={() => this.registerField({ name: "phone_number" })}>
								<Box>
									<BoxTitle>{translate("PHONE_NUMBER")}</BoxTitle>
									<MaskedInput>
										<MaskInput
											alwaysShowMask={window.IS_MARS ? true : false}
											maskChar="_"
											mask="00000000000"
											size={11}
											onChange={this.onEnterValue.bind(this, "phone_number")}
										/>
									</MaskedInput>
								</Box>
							</FormItem>
						</Fragment>
					)}
					{method === "APayImps" && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="_________________"
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>

							<FormItem onRegister={() => this.registerField({ name: "bank_code" })}>
								<Box>
									<BoxTitle>{translate("BANK_CODE")}</BoxTitle>
									<MaskedInput>
										<MaskInput
											alwaysShowMask={window.IS_MARS ? true : false}
											maskChar="_"
											mask="aaaa\0******"
											size={11}
											onChange={this.onEnterValue.bind(this, "bank_code")}
										/>
									</MaskedInput>
								</Box>
							</FormItem>
						</Fragment>
					)}
					{(method === "APayBkash_a" || method === "APayBkash_b") && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="_________________"
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>

							<FormItem
								onRegister={() => this.registerField({ name: "account_email" })}>
								<Box>
									<BoxTitle>{translate("BANK_CODE")}</BoxTitle>
									<StakeInput
										placeholder="_________________"
										onChange={this.onEnterValue.bind(this, "account_email")}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
					{(method === "APayNagadA" ||
						method === "APayNagadB" ||
						method === "ApayJazzCash") && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="_________________"
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
					{method === "APaySPEI" && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="_________________"
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>
							<FormItem onRegister={() => this.registerField({ name: "bank_code" })}>
								<Box>
									<BoxTitle>{translate("BANK_NAME")}</BoxTitle>
									<PaymentSelect
										value={bank_code}
										options={BANKS}
										handleSelect={this.onSelectBankCode.bind(this)}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const {
			stake,
			pixkey,
			account_number,
			selectedCurrency,
			crypto_currency,
			doc_number,
			crypto_payway,
			doc_type,
			banks,
			bank_id,
			bank_code,
			account_type,
		} = this.state;
		let withdrawData = {
			method: method.split("APay")[1],
			pixkey,
			type: "APay",
			account_number,
			crypto_currency,
			doc_number,
			crypto_payway,
			doc_type,
			bank_name: bank_code ? banks?.find((item) => item.id === bank_code)?.name : "",
			bank_id,
			bank_code,
			account_type,
			username: getUser().username,
			sessionId: getUser().sessionId,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
